import { SelectedProspectData } from '../../../../../../../sequence/types';

export function extractProspectAttributes(
  selectedProspectData: SelectedProspectData | null,
): Record<string, any> {
  const prospectAttributes: Record<string, any> = {};

  if (!selectedProspectData) {
    return prospectAttributes;
  }

  const attributeFields = ['First Name', 'Last Name', 'Email', 'Time Zone'];

  selectedProspectData?.attributes?.forEach(({ attributeValue, fieldRef }) => {
    const fieldLabel = fieldRef?.label?.trim();
    if (fieldLabel && attributeFields?.includes(fieldLabel)) {
      prospectAttributes[fieldLabel] = attributeValue;
    }
  });

  prospectAttributes.isBlacklisted =
    selectedProspectData?.isBlacklisted || false;

  return prospectAttributes;
}

export const getFirstName = (prospectAttributes: Record<string, any>): string =>
  prospectAttributes?.['First Name'] || '';

export const getLastName = (prospectAttributes: Record<string, any>): string =>
  prospectAttributes?.['Last Name'] || '';

export const getValidUrl = (url) => {
  if (!url) return null; // or '#'
  return url.startsWith('http://') || url.startsWith('https://')
    ? url
    : `https://${url}`;
};

export const getTruncateLengthEmailByScreen = (width: number) => {
  if (width >= 2560) return 15;
  if (width >= 2260) return 22;
  if (width >= 2000) return 18;
  if (width >= 1900) return 15;
  if (width >= 1744) return 16;
  if (width >= 1500) return 11;
  if (width >= 1265) return 8;
  if (width >= 1190) return 7;
  return 6;
};
export const getTruncateLengthEmailByScreenWithOutHover = (width: number) => {
  if (width >= 2560) return 15;
  if (width >= 2260) return 23;
  if (width >= 2000) return 18;
  if (width >= 1780) return 17;
  if (width >= 1600) return 16;
  if (width >= 1500) return 14;
  if (width >= 1450) return 13;
  if (width >= 1265) return 12;
  if (width >= 1190) return 7;
  return 6;
};
